import me from '../../images/me.png'
import me4 from '../../images/me4.jpg'
import me5 from '../../images/me5.jpg'

import user from '../../images/user.png'


import bg4 from '../../images/137.jpg'

import react from '../../images/react.png'
import js from '../../images/javascript.png'
import node from '../../images/nodejs.png'

const images = {
  me,
  me4,
  me5,
  user,
  bg4,
  react,
  js,
  node,
}

export default images